<template>
  <div class="resolution-selector" :class="{ compact }" role="group" aria-label="选择输出分辨率">
    <span v-if="showLabel">分辨率</span>
    <button
      v-for="option in options"
      :key="option"
      type="button"
      :class="{ active: value === option }"
      :disabled="disabled"
      @click="$emit('input', option)"
    >{{ option }}</button>
  </div>
</template>

<script>
import { MINIMUM_OUTPUT_RESOLUTION, OUTPUT_RESOLUTION_OPTIONS } from '@/utils/outputQuality'

export default {
  name: 'ResolutionSelector',
  props: {
    value: {
      type: String,
      default: MINIMUM_OUTPUT_RESOLUTION
    },
    disabled: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: [...OUTPUT_RESOLUTION_OPTIONS]
    }
  }
}
</script>

<style scoped>
.resolution-selector { display: inline-flex; align-items: center; gap: 3px; border: 1px solid #d9e0db; border-radius: 6px; padding: 3px; background: #f5f7f5; }
.resolution-selector > span { margin: 0 6px; color: #76817a; font-size: 9px; font-weight: 700; white-space: nowrap; }
.resolution-selector button { min-width: 38px; height: 28px; border: 0; border-radius: 4px; padding: 0 8px; background: transparent; color: #79837d; font-size: 9px; font-weight: 700; transition: .16s; }
.resolution-selector button:hover:not(:disabled) { color: #2559b2; background: #edf3fd; }
.resolution-selector button.active { background: #fff; color: #2563eb; box-shadow: 0 2px 7px rgba(37,51,43,.12); }
.resolution-selector button:disabled { cursor: wait; opacity: .6; }
.resolution-selector.compact > span { margin-left: 4px; }
.resolution-selector.compact button { min-width: 34px; height: 25px; padding: 0 6px; font-size: 8px; }
</style>
